
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M3.142.056C.567.052-.878 3.12.714 5.21l5.881 7.725c.465.61 1.09.99 1.757 1.141a.894.894 0 00-.345.706v2.275a.895.895 0 101.791 0v-2.275a.893.893 0 00-.3-.67 3.04 3.04 0 001.946-1.18l5.852-7.704c1.586-2.089.149-5.147-2.42-5.152l-5.88-.01zM2.1 4.086c-.682-.897-.063-2.212 1.04-2.21l5.854.01 5.88.01c1.1.002 1.716 1.313 1.037 2.208l-5.852 7.705a1.295 1.295 0 01-2.078 0z","clip-rule":"evenodd"}})])
          )
        }
      }
    